import { LatLng } from '@/models/location';

const randomInRange = (min: number, max: number): number =>
  Math.random() * (max - min) + min;

const randomIntInRange = (min: number, max: number): number =>
  Math.floor(Math.random() * (max - min + 1)) + min;

export const generateRandomLatLonArray = (
  lat1: number,
  lon1: number,
  lat2: number,
  lon2: number,
  minPoints: number,
  maxPoints: number
): LatLng[] => {
  const numPoints = randomIntInRange(minPoints, maxPoints); // Random number of points
  return Array.from({ length: numPoints }, () => ({
    latitude: randomInRange(Math.min(lat1, lat2), Math.max(lat1, lat2)),
    longitude: randomInRange(Math.min(lon1, lon2), Math.max(lon1, lon2)),
  }));
};
